import { createFileRoute, redirect } from "@tanstack/react-router";

/* A training job and the run that tracks it are one page: the job's id is `ftjob_` and its
   run's hex, so a link to a job opens its run. */
export const Route = createFileRoute("/_console/p/$org/$project/training/jobs/$jobId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/p/$org/$project/training/runs/$runId",
      params: {
        org: params.org,
        project: params.project,
        runId: params.jobId.replace(/^ftjob_/, ""),
      },
      replace: true,
    });
  },
});
